export enum DataStoreStatus {
    NOT_READY = "NOT_READY",
    SYNC_IN_PROGRESS = "SYNC_IN_PROGRESS",
    SYNC_COMPLETED = "SYNC_COMPLETED"
}